import { useContext } from "react";
import {
  DropdownToggle,
  ResponsiveDrawerDropdown,
  DropdownItem,
} from "@stadium/ui/src/components/bootstrap-dropdown";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import styles from "./main.module.scss";

const CheckboxDropdown = ({ parentLabel, label, data, className }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);
  const handleChecked = (id, onChange) => {
    onChange(id);
  };

  const renderMenuItem = ({ items, onChange, selectedIds }) => {
    if (items?.length > 0)
      return (
        <>
          {items.map((i) => (
            <DropdownItem
              styles={styles}
              key={i.id}
              isActive={selectedIds.includes(i.id)}
              onClick={() => handleChecked(i.id, onChange)}
            >
              {i.name}
            </DropdownItem>
          ))}
        </>
      );
  };

  return (
    <ResponsiveDrawerDropdown
      styles={styles}
      className={className}
      label={
        <DropdownToggle styles={styles} showDropdownIcon={!isMobileDevice}>
          {label}
        </DropdownToggle>
      }
      heading={<DropdownToggle styles={styles}>{parentLabel}</DropdownToggle>}
    >
      {data.map(renderMenuItem)}
    </ResponsiveDrawerDropdown>
  );
};

export default CheckboxDropdown;
